import { render, staticRenderFns } from "./MarketIntelligenceCard.vue?vue&type=template&id=55a6a1d2&scoped=true"
import script from "./MarketIntelligenceCard.vue?vue&type=script&lang=js"
export * from "./MarketIntelligenceCard.vue?vue&type=script&lang=js"
import style0 from "./MarketIntelligenceCard.vue?vue&type=style&index=0&id=55a6a1d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55a6a1d2",
  null
  
)

export default component.exports